'use client';

import { classes } from '@/uiPrimitives/base/classes.helpers';
import { TransactionBlock } from './Transaction.types';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { textBlock } from '@/uiPrimitives/typography/text';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { closeIcon } from '@/uiIcons/closeIcon.css';
import { icon } from '@/uiPrimitives/media/icon';
import { useFocusOnMount } from '@dop/shared/hooks/useFocusOnMount';
import { ElementRef } from 'react';
import { Translation } from '@/globals/translate/translations';
import { callToActionBox } from '@/uiComposites/interactive/callToAction';

export const SelectedRegion = ({
	transactionBlock,
	changeLabel,
}: {
	transactionBlock: TransactionBlock;
	changeLabel: Translation<'Choose a different municipality, province or water authority'>;
}) => {
	const closeBtnRef = useFocusOnMount<ElementRef<'a'>>();

	return (
		<DOPLink
			ref={closeBtnRef}
			aria-label={changeLabel}
			href={transactionBlock.filter.baseUrl}
			data-link-type="transactionBlockResetChosenRegionButton"
			className={classes(callToActionBox({}), shelf({ columnGap: '0 | p' }))}
		>
			<span className={classes(textBlock({}))}>
				{transactionBlock.transactionResults?.name}
			</span>
			<i
				className={classes(
					icon({
						icon: closeIcon,
						inlineSize: '-1 | small',
						blockSize: '-1 | small',
					}),
				)}
			/>
		</DOPLink>
	);
};
